var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 40,
    viewBox: "0 0 273 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2740_71657)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.933 24.5168C21.933 27.4403 21.356 29.6458 20.202 31.1204C19.0479 32.6014 17.2528 33.3387 14.8101 33.3387C12.3674 33.3387 10.5786 32.6014 9.44382 31.1204C8.30902 29.6394 7.73842 27.4403 7.73842 24.5168V3.5647H0V24.1064C0 29.2675 1.25661 33.2041 3.76983 35.9224C6.28306 38.6408 9.96313 40 14.8165 40C19.6698 40 23.3563 38.6408 25.8888 35.9224C28.4148 33.2041 29.6842 29.2675 29.6842 24.1064V3.5647H21.933V24.5168Z",
    fill: "#2C292A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6188 12.8549C47.689 12.8549 46.0734 13.1754 44.7655 13.8101C43.4576 14.4449 42.342 15.336 41.4124 16.4708V13.169H34.3984V39.6861H41.6752V26.1198C41.6752 23.8117 42.1946 22.023 43.2268 20.7536C44.259 19.4777 45.7208 18.843 47.6121 18.843C51.1896 18.843 52.9783 21.1318 52.9783 25.7095V39.6861H60.2551V25.2927C60.2551 20.8561 59.255 17.6761 57.2611 15.7463C55.2608 13.8166 52.7155 12.8549 49.6188 12.8549Z",
    fill: "#2C292A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1186 13.1626H64.8418V39.6861H72.1186V13.1626Z",
    fill: "#2C292A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2740_71657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 3,
    width: 9,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8477 3.56445V12.521L71.1692 9.18074C71.759 8.873 72.1245 8.26392 72.1245 7.59715V3.56445H64.8477Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2740_71657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4531 8.93696L67.7556 -0.000366211L76.507 7.15463L69.2045 16.0855L60.4531 8.93696Z",
    fill: "url(#paint0_linear_2740_71657)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8223 32.9284C84.4248 32.5181 84.226 31.8449 84.226 30.9152V19.3044H92.1888V13.1624H84.226V3.5647H76.9492V13.1624V19.3044V32.1013C76.9492 37.1598 79.4753 39.6859 84.5338 39.6859H92.4966V33.5439H86.8034C85.8801 33.5503 85.2198 33.3387 84.8223 32.9284Z",
    fill: "#2C292A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.557 14.4256C112.511 13.3742 110.146 12.8549 107.459 12.8549C104.811 12.8549 102.478 13.4126 100.465 14.5282C98.4515 15.6502 96.8871 17.2274 95.7716 19.279C94.656 21.3242 94.0918 23.722 94.0918 26.4788C94.0918 29.1972 94.6688 31.5822 95.8229 33.6274C96.9769 35.6726 98.6246 37.2498 100.779 38.3461C102.927 39.4489 105.485 40.0002 108.44 40.0002C110.71 40.0002 112.723 39.5963 114.48 38.7885C116.236 37.9807 117.647 36.8715 118.711 35.461C119.775 34.0506 120.449 32.467 120.724 30.7167H113.55C113.242 31.9541 112.595 32.8901 111.614 33.5312C110.633 34.166 109.402 34.4865 107.921 34.4865C106.062 34.4865 104.6 33.9352 103.536 32.8324C102.471 31.7297 101.849 30.2166 101.676 28.2932V28.0881H120.923C121.064 27.3636 121.128 26.5365 121.128 25.6133C121.096 23.036 120.5 20.7856 119.346 18.8815C118.205 16.9581 116.608 15.4771 114.557 14.4256ZM101.837 23.3309C102.042 21.7858 102.689 20.5548 103.773 19.6444C104.856 18.734 106.19 18.2788 107.773 18.2788C109.428 18.2788 110.793 18.7148 111.877 19.5931C112.96 20.4715 113.621 21.7153 113.864 23.3309H101.837Z",
    fill: "#2C292A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.355 16.4642C142.464 14.0536 139.797 12.8546 136.354 12.8546C134.014 12.8546 131.904 13.4124 130.032 14.528C128.154 15.6436 126.692 17.2271 125.647 19.2723C124.595 21.3175 124.076 23.6833 124.076 26.3696C124.076 29.088 124.602 31.4794 125.647 33.5439C126.698 35.6083 128.147 37.1983 130.007 38.3203C131.866 39.4358 133.962 40 136.302 40C139.777 40 142.528 38.6729 144.56 36.025L145.285 39.6859H151.632V3.5647H144.355V16.4642ZM142.707 31.9731C141.541 33.3643 139.97 34.0632 138.008 34.0632C136.046 34.0632 134.475 33.3579 133.289 31.9475C132.103 30.537 131.507 28.6969 131.507 26.4273C131.507 24.1577 132.097 22.3177 133.289 20.9072C134.475 19.4967 136.052 18.7915 138.008 18.7915C139.97 18.7915 141.534 19.4967 142.707 20.9072C143.874 22.3177 144.464 24.177 144.464 26.4786C144.464 28.7482 143.874 30.5818 142.707 31.9731Z",
    fill: "#2C292A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.001 24.6706H182.08V18.3235H165.001V10.2196H182.08V3.5647H157.256V39.6859H182.08V33.031H165.001V24.6706Z",
    fill: "#2C292A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.461 3.5647H186.723V39.6859H208.81V33.031H194.461V3.5647Z",
    fill: "#2C292A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.101 5.85994C232.331 4.32764 229.138 3.5647 225.529 3.5647H212.988V39.6859H225.529C229.138 39.6859 232.331 38.9165 235.101 37.3906C237.87 35.8583 240.005 33.7298 241.499 30.9922C242.993 28.261 243.743 25.1323 243.743 21.6253C243.743 18.1183 242.993 14.996 241.499 12.2584C239.999 9.52719 237.87 7.39223 235.101 5.85994ZM233.139 30.0625C231.331 32.1783 228.799 33.2361 225.529 33.2361H220.727V10.0144H225.529C228.799 10.0144 231.331 11.0723 233.139 13.188C234.947 15.3038 235.851 18.1183 235.851 21.6253C235.851 25.1323 234.947 27.9468 233.139 30.0625Z",
    fill: "#2C292A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.475 39.6861H262.214V10.2583L255.424 13.8486C254.841 14.1564 254.469 14.7654 254.469 15.4322V39.6861H254.475Z",
    fill: "#2C292A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M244.053 3.5647V10.2196L262.216 10.2581V10.2196H272.641V3.5647H244.053Z",
    fill: "#2C292A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2740_71657",
    x1: 64.6589,
    y1: 12.7108,
    x2: 72.3308,
    y2: 3.32397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB9823"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB723"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2740_71657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272.64,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/Logo (2).ab1a02ac2a1f0694547e91f106d3b9a0.svg";
export { ForwardRef as ReactComponent };